module.exports = __webpack_public_path__ + "static/media/tYoung.5e89c28a.jpeg";